import { NgModule } from '@angular/core';
import { IntegrationSemrushModule } from './semrush/semrush.module';
import { IntegrationServiceBase } from './services/integration.service.base';
import { IntegrationWinmoModule } from './winmo/winmo.module';

@NgModule({
    imports: [IntegrationSemrushModule, IntegrationWinmoModule],
    exports: [IntegrationSemrushModule],
    providers: [IntegrationServiceBase],
})
export class IntegrationsModule {}
